import { render, staticRenderFns } from "./TrustedDeviceManagement.vue?vue&type=template&id=67523168&"
import script from "./TrustedDeviceManagement.vue?vue&type=script&lang=js&"
export * from "./TrustedDeviceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports